export default __webpack_public_path__ + "static/media/1147.6017b99d.png";